module.exports = __webpack_public_path__ + "static/media/zind_karembure2.aca1945c.jpg";